import React from "react";
import "./CountyCard.css";
import Map from "./Map.js";
import { Link } from "react-router-dom";
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";

export default function CountyCard({ county, searchTerm }) {
  const HighlightText = ({ text }) => {
    if (!searchTerm || !text) {
      return text || "";
    }

    const textStr = String(text);

    // global and case insenstive = gi
    const regex = new RegExp(`(${searchTerm})`, "gi");
    return textStr?.split(regex).map((part, index) =>
      part.toLowerCase() === searchTerm.toLowerCase() ? (
        <mark key={index} style={{ backgroundColor: "yellow" }}>
          {part}
        </mark>
      ) : (
        part
      )
    );
  };

  return (
    <Card style={{ width: "18rem" }}>
      <Map
        latitude={county?.latitude}
        longitude={county?.longitude}
        height="200px"
        width="100%"
      />
      <Card.Body>
        <Card.Title
          as={Link}
          to={`/counties/${county?.id}`}
          style={{ fontSize: "24px", fontWeight: "600" }}
          id="county-name"
        >
          <HighlightText text={county?.name} />
        </Card.Title>
        {county.type && (
          <Card.Text>
            <b>Type: </b>
            <HighlightText text={county?.type} />
          </Card.Text>
        )}
        <Card.Text>
          <HighlightText text={county?.description} />
        </Card.Text>
      </Card.Body>
      <ListGroup className="list-group-flush">
        <ListGroup.Item>
          <b>Estimated Population (Past Year): </b>
          <HighlightText
            text={Number(county?.total_population)?.toLocaleString()}
          />
        </ListGroup.Item>
        <ListGroup.Item>
          <b>Median Household Income: </b>
          <HighlightText
            text={Number(county?.median_income)?.toLocaleString()}
          />
        </ListGroup.Item>
        <ListGroup.Item>
          <b>Unemployment Status: </b>
          <HighlightText text={county?.unemployment} />
        </ListGroup.Item>
        <ListGroup.Item>
          <b>Health and Insurance Coverage: </b>
          <HighlightText text={county?.health_coverage} />
        </ListGroup.Item>
      </ListGroup>
    </Card>
  );
}
